import {
  Box, CircularProgress, Container, FormControl, FormLabel, Text, useToast, VStack
} from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import Button from "components/Button/Button";
import Input from "components/Input/Input";
import useAuth from "hooks/useAuth";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { get, post } from "util/axiosLib";
import { showLastThreeChar } from "util/hideInfo";
import PhoneVerification from "./PhoneVerification";


const QUESTION_URL = `${process.env.REACT_APP_API_ENDPOINT}/auth/2fa/securityQuestion`;

const Forgot2FA = () => {
  const toast = useToast();
  const history = useHistory();
  const [codeSent, setCodeSent] = useState(false);
  const [securityQuestion, setSecurityQuestion] = useState("");
  const [questionState, setQuestionState] = useState("");

  const [step, setStep] = useState("");

  const [securityAnswer, setSecurityAnswer] = useState("");
  
  const { logout, profile, token, login } = useAuth();
  const headers = {
    authorization: token,
    "Content-Type": "application/json",
  };

  const handleNewSecuritySetup = async(e) => {
    e && e.preventDefault && e.preventDefault();
    try {
      setQuestionState({state: "submitting", msg: null})
      let urlString = QUESTION_URL;
      const response = await post(`${urlString}`, {
        securityQuestion,
        securityAnswer: String(securityAnswer).trim()
      }, {
        ...headers,
      });

      if (response?.data?.status === "success") {
        setSecurityQuestion(String(response?.data?.data?.question))
        setQuestionState({state: "", msg: null})
      } else {
        setQuestionState({state: "error", msg: "Something went wrong!"})
      } 
      setStep("resetting")
    } catch(error) {
      let errmsg = error ? error : "Please check your network connection";
      if(error?.error) {
        errmsg = String(error.error)
      }
      errmsg = typeof errmsg === "string" ? errmsg : "Something went wrong. Please try again";
      setQuestionState({state: "error", msg: errmsg}) 
      toast({
        position: "bottom-right",
        title: error ? "Something went wrong!" : "Network Error!!",
        description: errmsg,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }

  const fetchUserQuestion = async () => {
    const doError = (error) => {
      let errmsg = error ? error : "Please check your network connection";
      if(error?.error) {
        errmsg = String(error.error)
      }
      errmsg = typeof errmsg === "string" ? errmsg : "Something went wrong. Please try again";

      setQuestionState({state: "error", msg: errmsg})
      toast({
        position: "bottom-right",
        title: error ? "Something went wrong!" : "Network Error!!",
        description: errmsg,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
    try {
      if(navigator.onLine) {
        setQuestionState({state: "fetching", msg: null})
        let urlString = QUESTION_URL;
        const response = await get(`${urlString}`, {
          ...headers,
        });

        if (response?.data?.status === "success") {
          setSecurityQuestion(response?.data?.data?.question)
          setQuestionState({state: "", msg: null})
        } else {
          setQuestionState({state: "error", msg: "Error"})
        } 
      } 
      else {
        doError()
      }
    } catch(err) {
      console.log("na here oo", err, Object.keys(err))
      if(err?.error && String(err.error).toLowerCase().includes("security question has not been provided")) {
        setStep("no_question")
      } else {
        doError(err)
      }
    }
  }

  useEffect(() => {
    if(step === "user_promise") {
      fetchUserQuestion();
    }
  // eslint-disable-next-line 
  }, [step])

  return (
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="lg">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          {step === "" && 
            <>
              <VStack>
                <Box
                  w={["100px", "initial"]}
                  as={Logo}
                  cursor="pointer"
                  onClick={() => {
                    logout();
                    history.replace("/");
                  }}
                />
                {profile?.data?.firstName && <Text
                  textAlign="center"
                  fontSize={["32px", "3xl"]}
                  mt="4rem !important">
                  Hi {profile?.data.firstName},
                </Text>}
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  We are sorry to learn that you are encountering issues with your two factor authentication.
                </Text>
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  Now let us help you get back your account without compromising your security.
                </Text>
              </VStack>

              <VStack gridGap="2rem">
                <Button
                  minW="100%"
                  minH="56px"
                  fontWeight="normal"
                  mt="30px !important"
                  onClick={() => setStep("user_ready")}
                >
                  Yes, let's do it
                </Button>

            </VStack>
            </>
          }
          {step === "user_ready" && 
            <>
              <VStack>
                <Box
                  w={["100px", "initial"]}
                  as={Logo}
                  cursor="pointer"
                  onClick={() => {
                    logout();
                    history.replace("/");
                  }}
                />
                <Text
                  textAlign="center"
                  fontSize={["32px", "3xl"]}
                  mt="4rem !important">
                  Awesome!!!
                </Text>
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  We will ask you a very simple question that only you should be able to answer. If you have never shared your secret question with us before, you will be able to do so only this one time.
                </Text>
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  Promise us you will not forget this one.
                </Text>
              </VStack>

              <VStack gridGap="2rem">
                <Button
                  minW="100%"
                  minH="56px"
                  fontWeight="normal"
                  mt="30px !important"
                  onClick={() => setStep("user_promise")}
                >
                  I Promise
                </Button>
                {2+2===5 && <Button
                  minW="100%"
                  minH="56px"
                  fontWeight="normal"
                  mt="30px !important"
                  onClick={() => setStep("user_gruntle")}
                >
                  Whatever
                </Button>}

            </VStack>
            </>
          }
          {["user_gruntle", "user_promise"].includes(step) && 
            <>
            {questionState.state === "fetching" ? 
              <VStack>
                <Box
                  w={["100px", "initial"]}
                  as={Logo}
                  cursor="pointer"
                  onClick={() => {
                    logout();
                    history.replace("/");
                  }}
                />
                <Text
                  textAlign="center"
                  fontSize={["16px", "xl"]}
                  mt="4rem !important"
                  mb="1rem !important"
                >
                  Loading...
                </Text>
                
                <CircularProgress mt={"5rem"} size="32px" isIndeterminate color="green.300" />
              </VStack> :
            questionState.state === "error" ? 
              <VStack>
                <Box
                    w={["100px", "initial"]}
                    as={Logo}
                    cursor="pointer"
                    onClick={() => {
                      logout();
                      history.replace("/");
                    }}
                  />
                <Text
                  textAlign="center"
                  fontSize={["32px", "3xl"]}
                  mt="4rem !important">
                  Something went wrong.
                </Text>
                
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  {questionState.msg || ""}
                </Text>
                {questionState.msg && String(questionState.msg).toLowerCase().includes("no 2fa is registered") ? <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  You can try to log out and log back in. The error might have auto resolved. If it didn't, Please contact our Customer service for assistance.
                </Text> : null}
              </VStack> : 
              <>
                <VStack>
                  <Box
                    w={["100px", "initial"]}
                    as={Logo}
                    cursor="pointer"
                    onClick={() => {
                      logout();
                      history.replace("/");
                    }}
                  />
                  <Text
                    textAlign="center"
                    fontSize={["32px", "3xl"]}
                    mt="4rem !important">
                    {step === "user_promise" ? "Perfect!!! " : "Now let's get this done quickly"} 
                  </Text>
                  <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                    Provide an answer to your security question below                
                  </Text>
                  <Box as="form" mt="1rem" w={"100%"}>
                  <FormControl mt="2rem" p="1rem 10px" w={"100%"} border="1px solid gray.500">
                    <Text as="em"  textAlign="center" color="gray.500" mb="1rem" fontSize={["12px", "xl"]}>
                      <blockquote>"{String(securityQuestion)}"</blockquote>
                    </Text>
                  </FormControl>
                  <FormControl>
                      <FormLabel>Security Answer</FormLabel>
                      <Input
                        w="100%"
                        value={securityAnswer}
                        isRequired
                        placeholder="Enter your security answer here"
                        onChange={(e) => setSecurityAnswer(e.target.value)}
                      />

                      <Button
                        minH="40px"
                        fontWeight="normal"
                        mt="30px !important"
                        type="submit"
                        isLoading={questionState.state === "submitting"}
                        disabled={(securityAnswer.length > 50) || !securityAnswer.length || (questionState.state === "error") || questionState.state === "fetching"}
                        onClick={() => {
                          setStep("resetting")
                        }}>
                        Submit
                      </Button>
                    </FormControl>
                  </Box>
                </VStack>
              </>}
            </>
          }
          {["new_security_question"].includes(step) && 
            <>
              <VStack>
                <Box
                  w={["100px", "initial"]}
                  as={Logo}
                  cursor="pointer"
                  onClick={() => {
                    logout();
                    history.replace("/");
                  }}
                />
                {questionState.state === "error" && questionState.msg ? <Text textAlign="center" fontSize={["sm", "md"]} color="#F56565">
                  {String(questionState.msg)}               
                </Text> : null}
                <Text
                  textAlign="center"
                  fontSize={["32px", "3xl"]}
                  mt="4rem !important">
                  Create your security question
                </Text>
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  And provide an answer to your security question below                
                </Text>
                <Box as="form" w="100%">
                  <FormControl mt="2rem">
                    <FormLabel>Security Question</FormLabel>
                    <Input
                      w="100%"
                      value={securityQuestion}
                      placeholder="Enter your security question here"
                      onChange={(e) => setSecurityQuestion(e.target.value)}
                    />
                  </FormControl>
                  {securityQuestion ? <FormControl mt={"1rem"}>
                      <FormLabel>Security Answer</FormLabel>
                      <Input
                        w="100%"
                        value={securityAnswer}
                        isRequired
                        placeholder="Enter your security answer here"
                        onChange={(e) => setSecurityAnswer(e.target.value)}
                      />

                      <Button
                        minH="40px"
                        fontWeight="normal"
                        mt="30px !important"
                        isLoading={questionState.state === "submitting"}
                        disabled={(securityQuestion.length > 200) || !securityQuestion?.length || questionState.state === "submitting"}
                        onClick={handleNewSecuritySetup}>
                        Submit
                      </Button>
                    </FormControl> : null}
                </Box>
              </VStack>

            </>
          }
          {step === "no_question" && 
            <>
              <VStack>
                <Box
                  w={["100px", "initial"]}
                  as={Logo}
                  cursor="pointer"
                  onClick={() => {
                    logout();
                    history.replace("/");
                  }}
                />
                <Text
                  textAlign="center"
                  fontSize={["32px", "3xl"]}
                  mt="4rem !important">
                  Oops!!! This is your first time.
                </Text>
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  You need to create your security question and answer, then we will resume the previous step
                </Text>
              </VStack>

              <VStack gridGap="2rem">
                <Button
                  minW="100%"
                  minH="56px"
                  fontWeight="normal"
                  mt="30px !important"
                  onClick={() => setStep("new_security_question")}
                >
                  Proceed
                </Button>
                
              </VStack>
            </>
          }
          {step === "resetting" && 
            <>
              <VStack>
                <Box
                  w={["100px", "initial"]}
                  as={Logo}
                  cursor="pointer"
                  onClick={() => {
                    logout();
                    history.replace("/");
                  }}
                />
                <Text
                  textAlign="center"
                  fontSize={["32px", "3xl"]}
                  mt="4rem !important">
                  Security Verification
                </Text>
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  {!codeSent ? "To secure your account, request a confirmation code to your registered phone number and provide the code in the input below" : 
                  `Provide the code sent to *********${showLastThreeChar(
                    profile?.data?.phone && profile?.data.phone
                  )}`}
                </Text>
              </VStack>

              <VStack gridGap="2rem">
              <PhoneVerification
                data={securityAnswer}
                profile={profile.data}
                token={token}
                login={login}
                enableRecaptcha={false}
                hidePhoneText={true}
                onComplete={() => {
                  setStep("reset_email")
                }}
                updateOnRequest={(_success, err) => {
                  if(!err) setCodeSent(true);
                }}
              />

              </VStack>
            </>
          }
          {step === "reset_email" && 
            <>
              <VStack>
                <Box
                  w={["100px", "initial"]}
                  as={Logo}
                  cursor="pointer"
                  onClick={() => {
                    logout();
                    history.replace("/");
                  }}
                />
                <Text
                  textAlign="center"
                  fontSize={["32px", "3xl"]}
                  mt="4rem !important">
                  Hurray!!! It's almost over
                </Text>
                <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
                  We have sent you an email with a link to reset your 2FA. Click on the link in the mail to complete the reset or to generate a new 2FA secret.
                </Text>
              </VStack>
            </>
          }
          <VStack gridGap="2rem">
            <Box
              w={["100px", "initial"]}
              as={"div"}
              mt={["5rem", "10rem"]}
              cursor="pointer"
              display="flex" 
              justifyContent="center"
              onClick={() => {
                logout();
                history.replace("/");
              }}>
              <button
                style={{
                  color: "#03A438",
                  cursor: "pointer",
                }}>
                Logout
              </button>
            </Box>
          </VStack>
        </Box>
      </Container>
    </VStack>
  );
};

export default Forgot2FA;
